/* ============================================================
   TODROKI — 2026 enhancement layer
   Vanilla JS, no dependencies, deferred.
   Everything here is progressive enhancement:
   the site is fully functional if this file never runs.
   ============================================================ */
(function () {
  'use strict';

  document.documentElement.classList.remove('no-td-js');

  /* ----------------------------------------------------------
     1. Scroll-state header
     ---------------------------------------------------------- */
  var header = document.querySelector('.bwp-header');
  if (header) {
    var lastState = false;
    var inFlow = false;
    var flowHeight = 0;
    try {
      var pos = window.getComputedStyle(header).position;
      inFlow = (pos !== 'absolute' && pos !== 'fixed');
      flowHeight = header.offsetHeight;
    } catch (e) { /* noop */ }

    var onScroll = function () {
      var scrolled = window.scrollY > Math.max(260, flowHeight + 160);
      if (scrolled !== lastState) {
        lastState = scrolled;
        header.classList.toggle('td-scrolled', scrolled);
        /* keep document height stable when the header leaves the flow */
        if (inFlow) {
          document.body.style.paddingTop = scrolled ? flowHeight + 'px' : '';
        }
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ----------------------------------------------------------
     2. Reveal on scroll (IntersectionObserver)
        Auto-targets custom sections + product cards.
     ---------------------------------------------------------- */
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!prefersReduced && 'IntersectionObserver' in window) {
    var autoTargets = document.querySelectorAll(
      '.td-heading, .td-editorial__media, .td-editorial__copy, .products-grid .product-card, .featured-products-grid .product-card'
    );
    autoTargets.forEach(function (el) { el.classList.add('td-reveal'); });

    /* stagger product cards subtly */
    document.querySelectorAll('.product-card.td-reveal').forEach(function (el, i) {
      el.style.setProperty('--td-delay', ((i % 4) * 0.07) + 's');
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

    document.querySelectorAll('.td-reveal').forEach(function (el) { io.observe(el); });

    /* observe late-added cards (ajax load-more) */
    var grid = document.querySelector('.products-grid, [data-collection-container]');
    if (grid && 'MutationObserver' in window) {
      new MutationObserver(function (muts) {
        muts.forEach(function (m) {
          m.addedNodes.forEach(function (n) {
            if (n.nodeType !== 1) return;
            var cards = n.matches && n.matches('.product-card') ? [n] : n.querySelectorAll ? n.querySelectorAll('.product-card') : [];
            Array.prototype.forEach.call(cards, function (c) {
              c.classList.add('td-reveal');
              io.observe(c);
            });
          });
        });
      }).observe(grid, { childList: true, subtree: true });
    }
  }

  /* ----------------------------------------------------------
     3. Marquee tracks — duplicate content until seamless
     ---------------------------------------------------------- */
  document.querySelectorAll('.td-band__track, .td-hero__wordmark-track').forEach(function (track) {
    var original = track.innerHTML;
    var guard = 0;
    while (track.scrollWidth < window.innerWidth * 2.2 && guard < 12) {
      track.innerHTML += original;
      guard++;
    }
  });

  /* ----------------------------------------------------------
     4. Intro overlay — add a visible "enter" affordance
        (only when the merchant's intro section is present
         and has not been played this session)
     ---------------------------------------------------------- */
  var intro = document.querySelector('.intro-window');
  if (intro && !sessionStorage.getItem('videoPlayed') && intro.style.display !== 'none') {
    var hint = document.createElement('div');
    hint.className = 'td-enter-hint';
    hint.setAttribute('aria-hidden', 'true');
    hint.textContent = 'TAP TO ENTER';
    intro.appendChild(hint);
    intro.addEventListener('click', function () { hint.remove(); }, { once: true });
  }
})();
